export const types = <const>{
	mutations: {
		PLANOVANA_PUJCKA_FILTER_VOZIDLO: 'PLANOVANA_PUJCKA_FILTER_VOZIDLO',
		PLANOVANA_PUJCKA_FILTER_ZAKAZNIK: 'PLANOVANA_PUJCKA_FILTER_ZAKAZNIK',
	},
};
